import FilterDrawer from '@cp/src/components/FilterDrawer';
import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { SearchIcon } from '@navi/web-ui/lib/icons';
import { BorderedInput, Typography } from '@navi/web-ui/lib/primitives';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ENTER_KEY } from '../../CsaTicketing/constants';
import { ITableHeader } from '../types';
import styles from './index.module.scss';
import Switch from '@cp/src/components/Switch/Switch';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';

const TableHeader = (props: ITableHeader) => {
  const { filterSchema, fetchData, tableName, clickstreamTableName } = props;
  const params = readQueryParams();
  const navigate = useNavigate();

  const searchParam = params?.[tableName]?.searchText;
  const unreadParam = params?.[tableName]?.showUnread === 'true';

  const [showUnread, setShowUnread] = useState(unreadParam);
  const [searchText, setSearchText] = useState(searchParam);

  const fetchDataWithQuery = (searchText: string) => {
    const updatedParams = { ...params };
    updatedParams[tableName].searchText = searchText;
    updatedParams[tableName].pageNumber = '1';
    const url = createQueryParams(updatedParams);
    navigate(url);
    fetchData();
  };

  const onKeyDownHandler = (e?: React.KeyboardEvent<HTMLInputElement>) => {
    if (e?.key === ENTER_KEY) {
      e.preventDefault();
      if (!searchText) return;
      fetchDataWithQuery(searchText);
    }
  };

  const toggleShowUnread = () => {
    const updatedParams = { ...params };
    updatedParams[tableName].showUnread = !showUnread ? 'true' : 'false';
    updatedParams[tableName].pageNumber = '1';
    const url = createQueryParams(updatedParams);
    navigate(url);
    setShowUnread(!showUnread);
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_TASKS_UNREAD_TOGGLE_CLICKED);
    fetchData();
  };

  const searchTextHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e?.target?.value);
    if (e.target.value === '') {
      fetchDataWithQuery('');
    }
  };

  const applyFilters = () => {
    const queryParams = readQueryParams();
    const updatedParams = { ...queryParams };
    updatedParams[tableName].pageNumber = '1';
    const paramsData = createQueryParams(updatedParams);
    navigate(paramsData);
    fetchData();
  };

  return (
    <div className="flex items-start gap-6 p-6">
      <BorderedInput
        LeftInputAdornment={<SearchIcon size="sm" />}
        containerClassName={styles.searchBar}
        value={searchText}
        placeholder="Search by customer name or LAN"
        onKeyDown={onKeyDownHandler}
        onChange={searchTextHandler}
      />
      <div className="flex gap-4 flex-1 items-start">
        <FilterDrawer
          filterSchema={filterSchema}
          filterButtonTitle="Filters"
          drawerContainerClass="!w-[360]"
          selectedFiltersClass="!p-0"
          onApply={applyFilters}
          tableName={clickstreamTableName}
        />
        <div className={styles.verticalLine} />
        <div className={styles.unreadWrapper}>
          <Switch
            checked={showUnread}
            onChange={toggleShowUnread}
            headerText={
              <Typography variant="h4" color="var(--grayscale-2)" className="font-normal">
                Show unread
              </Typography>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default TableHeader;
